export const SUBMIT_SUCCESS_TEXT = `Спасибо за обращение! В ближайшее время мы опубликуем ваш отзыв.`;
